// extracted by mini-css-extract-plugin
module.exports = {"container":"article-heading-module--container--2xXkn","excerpt":"article-heading-module--excerpt--w3OY3"};